import { withCurrentParams } from 'actions/utils';
import { BANNER_ADD } from 'store/eventConstants';
import { BROADCAST_DUPLICATE_BANNER } from 'actions/Types';

export default bannerId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { banners } = getState();
      const banner = banners.find(banner => banner._id === bannerId);

      const action = {
        type: BROADCAST_DUPLICATE_BANNER,
        request: async apiClient => {
          const { source, layer } = banner;

          const { title, style } = layer;

          const payload = {
            layer: {
              title,
              style
            },
            source: {
              title: `COPY - ${source.title}`,
              value: { ...source.value },
              type: source.type
            }
          };

          const broadcast = await apiClient.broadcast.createBanner(
            teamId,
            eventId,
            broadcastId,
            payload
          );

          const { banners } = broadcast;
          // notify other directors
          socket.emit(BANNER_ADD, { broadcastId });
          return banners;
        }
      };

      dispatch(action);
    }
  );
};
